import { render } from "./Chat.vue?vue&type=template&id=15a6951b&ts=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15a6951b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15a6951b', __exports__)) {
    api.reload('15a6951b', __exports__)
  }
  
  module.hot.accept("./Chat.vue?vue&type=template&id=15a6951b&ts=true", () => {
    api.rerender('15a6951b', render)
  })

}


export default __exports__